import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {Role} from "./Role";
import _ = require('lodash');
import {Upload} from "./Upload";

export class Tenant extends BaseModel {
	id: string
	title: string
	vatId: string
	companyId: string
	accountNumber: string
	address: string
	invoiceBackground: string
	invoiceText: string
	invoiceResponsible: string
	uploads: Upload[]
	invoiceHeaderImageId: string
	invoiceFooterImageId: string
	invoiceHeaderImage: string
	invoiceFooterImage: string
}

export class TenantDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static title: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static vatId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static companyId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static accountNumber: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static address: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static invoiceResponsible: AttributeDescriptor = {validation: []}
	static invoiceText: AttributeDescriptor = {validation: []}
	static invoiceBackground: AttributeDescriptor = {validation: []}
	static invoiceHeaderImageId: AttributeDescriptor = {validation: []}
	static invoiceFooterImageId: AttributeDescriptor = {validation: []}
}